import { FormArray, ValidatorFn } from "@angular/forms";
import { CompositeData } from "./generated/types";

export const sumOfCompositeFractionsValidator: ValidatorFn = (formArray: FormArray) => {
  const value = formArray.value as CompositeData[];
  const sum = value.reduce((sum, d) => sum + d.fraction * 1000, 0);
  return sum !== 1000 ? { percent: true } : {};
}
